/**
 * Datumsrechnung des Grundkalenders — ausschliesslich auf ISO-Tagen in UTC-Mitternacht.
 *
 * Objektzeit kommt serverautoritativ aus dem Readmodel (`objectToday`); `objectIsoToday` ist
 * nur der Startwert, bis die erste Antwort da ist.
 */
export function parseIso(value: string): Date {
  return new Date(`${value}T00:00:00Z`);
}

export function addIsoDays(value: string, days: number): string {
  const date = parseIso(value);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function diffIsoDays(from: string, to: string): number {
  return Math.round((parseIso(to).getTime() - parseIso(from).getTime()) / 86_400_000);
}

export function isWeekendIso(value: string): boolean {
  const day = parseIso(value).getUTCDay();
  return day === 0 || day === 6;
}

export function clampIso(value: string, min: string, max: string): string {
  if (value < min) return min;
  if (value > max) return max;
  return value;
}

export function objectIsoToday(timezone = 'Europe/Berlin'): string {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  return formatter.format(new Date());
}

/** Ein echter Kalendertag, nicht nur die Form: „2026-13-45" aus einer URL brächte die Seite zum Absturz. */
export function isIsoDate(value: unknown): value is string {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
}
